import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function UserLookUp() {
  return (
    <Page
      title='User Look Up'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'User Look Up',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/user-look-up',
  component: UserLookUp,
  type: 'auth',
});
